import { useUserLoginHistory } from '@ukpostbox/client-data';
import {
	AlertBanner,
	Button,
	ContentBlock,
	ContentLoader,
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';
import { useSite } from '../../../../../_Global/Providers/SiteInterfaceProvider';
import { LoginHistoryEntry } from '../Components/LoginHistoryEntry';
import { BrowserIcon, UserDevice } from '../Util/LoginHistoryUtils';

const agents = [
	'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_5) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/85 Version/11.1.1 Safari/605.1.15',
	'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_10_4) AppleWebKit/600.7.12 (KHTML, like Gecko) Version/8.0.7 Safari/600.7.12',
	'Mozilla/5.0 (Linux; Android 4.0.4; Galaxy Nexus Build/IMM76B) AppleWebKit/535.19 (KHTML, like Gecko) Chrome/18.0.1025.133 Mobile Safari/535.19',
	'Mozilla/5.0 (Linux; Android 4.4; Nexus 5 Build/_BuildID_) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/30.0.0.0 Mobile Safari/537.36',
	'Mozilla/5.0 (Linux; Android 5.0.2; SAMSUNG SM-G925F Build/LRX22G) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/4.0 Chrome/44.0.2403.133 Mobile Safari/537.36',
	'Mozilla/5.0 (Linux; U; Android 10; SM-G960F Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/95.0.4638.50 Mobile Safari/537.36 OPR/60.0.2254.59405',
];

function LoginHistory() {
	const currentUserAgent = new UAParser();
	const testUserAgent = new UAParser(agents[3]);

	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();

	const [currentAgent, setCurrentAgent] = useState<any>({ debug: null, string: '' });

	const { status, data, error } = useUserLoginHistory();

	const GetAgentData = () => {
		// @ts-ignore
		if (navigator.userAgentData) {
			// @ts-ignore
			navigator.userAgentData.getHighEntropyValues(['model', 'platform', 'platformVersion']).then((r: any) => {
				const newResponse = window.structuredClone(r);

				newResponse.brands =
					newResponse.brands.length > 0
						? newResponse.brands.filter(
								(item: any) => !item.brand.includes('Not') && !item.brand.includes('Chromium'),
							)
						: newResponse.brands;

				const rexul = `${newResponse.brands.length > 0 && newResponse.brands[0] ? `${newResponse.brands[0].brand} ${newResponse.brands[0].version}` : ''} ${newResponse.model ? newResponse.model : ''} ${newResponse.platform ? newResponse.platform : ''} ${newResponse.platformVersion ? newResponse.platformVersion : ''}`;

				setCurrentAgent({ debug: newResponse.brands.length > 0 ? newResponse : null, string: rexul });
			});
		} else {
			setCurrentAgent({ data: null, string: navigator.userAgent });
		}
	};

	useEffect(() => {
		updatePageMeta({
			title: t('settings.loginHistory.title'),
		});
	}, [currentLocale]);

	return (
		<StackVertical gap={FlexGap.Small}>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>{t('settings.loginHistory.title')}</h2>
				<Button title={t('settings.loginHistory.actions.checkApi')} onClick={() => GetAgentData()} />
			</StackHorizontal>

			{currentAgent.debug && (
				<AlertBanner
					title={t('settings.loginHistory.labels.apiViewingWith')}
					icon={BrowserIcon(currentUserAgent.getUA(), currentAgent.debug)}
					content={UserDevice(currentUserAgent.getUA(), currentAgent.debug)}
				/>
			)}

			<AlertBanner
				title={t('settings.loginHistory.labels.viewingWith')}
				icon={BrowserIcon(currentUserAgent.getUA())}
				content={UserDevice(currentUserAgent.getUA())}
			/>

			{/*            <AlertBanner
                title={'Currently Viewing With:'}
                icon={BrowserIcon(testUserAgent.getUA())}
                content={`${testUserAgent.getDevice().vendor ? `${testUserAgent.getDevice().vendor} ${currentUserAgent.getDevice().model ? currentUserAgent.getDevice().model : ''} - ` : ''}${testUserAgent.getBrowser().name} ${testUserAgent.getBrowser().version} - ${testUserAgent.getOS().name} ${testUserAgent.getOS().version}`}
            />


            <ListItem developerOption={true} title={window.navigator.userAgent} hideSeparator={true} hideArrow={true} static={true}/>
*/}
			<div className='card'>
				<div className='list-group login-list-group'>
					{status === 'pending' ? (
						<ContentLoader childCount={10} childHeight='7em' />
					) : status === 'error' ? (
						<ContentBlock error title={error.name} content={error.message} />
					) : (
						data &&
						data.map((item) => <LoginHistoryEntry key={`loginHistoryItem${item.loginDate}`} {...item} />)
					)}
				</div>
			</div>
		</StackVertical>
	);
}

export default LoginHistory;
